import { GoogleSlidesApiConfig } from "../entities/AppConfig";

interface GoogleAuthService {
  state?: string;
  urlConfig: UrlConfig;
}

interface UrlConfig {
  clientId: string;
  redirectUrl: string;
  scope: string;
}

class GoogleAuthService {
  constructor(api: string, state: string, config: GoogleSlidesApiConfig) {
    this.state = state ? state : undefined;

    if(api === "slides") {
      this.urlConfig = {
        clientId: config.clientId,
        redirectUrl: config.oAuthRedirectUrl,
        scope: config.scope,
      };
    }
  }

  authServiceRedirect() {
    if(!this.urlConfig) return;
    let authUri = this.generateGoogleAuthRedirectUri();
    window.open(authUri, '_blank');
  }

  //discovery url- https://www.googleapis.com/discovery/v1/apis/slides/v1/rest
  //oauth docs- https://developers.google.com/identity/protocols/oauth2/javascript-implicit-flow#oauth-2.0-endpoints
  generateGoogleAuthRedirectUri() {
    let oauthBaseUrl = 'https://accounts.google.com/o/oauth2/v2/auth';
    let client_id = this.urlConfig.clientId;
    let redirect_uri = this.urlConfig.redirectUrl;
    let scope = this.urlConfig.scope;

    //NOTE: state query param can be used to persist any nec info during redirects
    return encodeURI(`${oauthBaseUrl}?scope=${scope}&include_granted_scopes=true&response_type=token&redirect_uri=${redirect_uri}&client_id=${client_id}${this.state && `&state=${this.state}`}`);
  }
}

export default GoogleAuthService;